import { http, apiMipe } from '@/core/api/';
import service from '@/services/pei/general';

const deticketsBaseURL = 'api/supportticket';

export const getUserCases = (params, pageIndex, pageSize) =>
  http.get(`${deticketsBaseURL}/search`, {
    params: { ...params, pageIndex, pageSize },
  });

export const getUserCaseStatus = () => http.get(`${deticketsBaseURL}/status`);

export const deleteCase = (itemId) =>
  http.delete(`${deticketsBaseURL}/case`, {
    params: {
      itemId,
    },
  });

export const getUserCaseModules = () => http.get(`${deticketsBaseURL}/modules`);

export const getUserCaseScreens = (moduleId) =>
  http.get(`${deticketsBaseURL}/screens/${moduleId}`);

export const getUserCaseReferenceNumberTypes = (params) =>
  http.get(`${deticketsBaseURL}/referencenumbertypes`, { params: params });

export const getUserCaseById = (itemId) =>
  http.get(`${deticketsBaseURL}/case/${itemId}`);

export const saveUserCase = (formData) =>
  http.post(`${deticketsBaseURL}/create`, formData);

export const downloadDocument = async (documentId) => {
  http.get(`${deticketsBaseURL}/download/${documentId}`).then((res) => {
    const document = res.data;
    service.documentDownloadReport(document.content, document.filename);
  });
};

export const saveAdditionalInfo = (formData) =>
  http.post(`${deticketsBaseURL}/saveadditionalinformation`, formData);

export const getCommentHistory = (caseNumber) =>
  http.get(`${deticketsBaseURL}/commentshistory`, {
    params: { caseNumber },
  });

export const getPreviousContactInformation = () =>
  apiMipe.get(`${deticketsBaseURL}/previouscontactinformation`);

export const validateReferenceNumber = (reference, referenceType) =>
  http.get(
    `${deticketsBaseURL}/validatereferencenumber?reference=${reference}&referenceType=${referenceType}`
  );
